import { render, staticRenderFns } from "./noticeArea.vue?vue&type=template&id=45cac882&scoped=true"
import script from "./noticeArea.vue?vue&type=script&lang=js"
export * from "./noticeArea.vue?vue&type=script&lang=js"
import style0 from "./noticeArea.vue?vue&type=style&index=0&id=45cac882&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cac882",
  null
  
)

export default component.exports